import type { IconSvgObject } from './types';

const GlassWaterIcon: IconSvgObject = [
  ["path", { d: "M18 2H6C5.44772 2 5 2.44772 5 3L6.85863 20.657C6.93899 21.4204 7.58275 22 8.35039 22H15.6496C16.4172 22 17.061 21.4204 17.1414 20.657L19 3C19 2.44772 18.5523 2 18 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 10C6.86548 9.35089 7.91815 9 9 9C10.0819 9 11.1345 9.35089 12 10C12.8655 10.6491 13.9181 11 15 11C16.0819 11 17.1345 10.6491 18 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default GlassWaterIcon;
